import { typedRpc } from "@/integrations/supabase/typedRpcClient";

export const requestPortfolio = async (
  profileId: string,
  anonymousId?: string | null,
  userId?: string | null
) => {
  try {
    const { data, error } = await typedRpc.call("handle_portfolio_request", {
      p_profile_id: profileId,
      p_user_id: userId || null,
      p_anonymous_id: anonymousId,
    });
    if (error) {
      console.error("Error requesting portfolio:", error);
      return false;
    }
    return true;
  } catch (error) {
    console.error("Error requesting portfolio:", error);
  }
};
